<script>
import ListingModel from "@/views/Edms/TemplateApplication/Components/ListingModel.vue";

export default {
    name: "TemplateApplications",
    components: {ListingModel},
}

</script>

<template>
    <ListingModel/>
</template>